module.exports = __webpack_public_path__ + "assets/img/7fenxiang-m.baad3b92.png";